import { IonButton } from "@ionic/react";
import React from "react";
import clsx from "clsx";

import styles from "./TeacherButton.module.scss";

type Props = React.ComponentProps<typeof IonButton> & {
  customType?: "solid" | "outline" | "strong-outline";
};

const TeacherButton = ({ customType = "solid", children, ...props }: Props) => {
  return (
    <IonButton
      {...props}
      strong={customType === "solid" || customType === "strong-outline"}
      expand="block"
      className={clsx(
        styles.button,
        customType === "solid" && styles.solid,
        customType === "outline" && styles.outline,
        customType === "strong-outline" && styles.strongOutline,
      )}
    >
      {children}
    </IonButton>
  );
};

export default TeacherButton;
